export const getAccountSubscription = (state: {
  account: { subscriptions: bb.model.account.ICurrentPlan };
}) => {
  return state.account.subscriptions;
};

export const getAccountBilling = (state: {
  account: { currentPlan: bb.model.account.ICurrentPlan };
}) => {
  console.log("account", state.account);
  return state.account.currentPlan.billingInfo;
};

export const getAccountInvoices = (state: {
  account: { invoices: bb.model.account.IInvoice };
}) => {
  return state.account.invoices;
};

export const getUpcomingInvoice = (state: {
  account: { upcomingInvoice: bb.model.account.IUpcomingInvoice | null};
}) => {
  return state.account.upcomingInvoice
}

export const getBundleSubscritpion = (state: {
  account: { bundleScription: boolean };
}) => {
  return state.account.bundleScription;
}

export const getEligibleRenewal = (state: {
  account : { eligibleRenewal: bb.model.account.IEligibleRenewal};
}) => {
  return state.account.eligibleRenewal;
}

export const getPlanProvider = (state: {
  account: { planProviders: bb.model.account.IUserPlanProviders };
  }) => {
  return state.account.planProviders;
}

export const getUserPlans = (state: {
  account: { plans: bb.model.account.IPlans };
}) => {
  return state.account.plans;
}